import Carousel from "./Carousel";
import SectionHdr from "./SectionHeader";

export default function TrendingSection({ books = [], selectedBooks = [], itemLimit = 8, onView, cart, addCart }) {
    const manualBooks = selectedBooks.slice(0, itemLimit);
    let BESTSELLERS = manualBooks.length
        ? manualBooks
        : books.filter(b => b.badge === "Bestseller" || b.rating >= 4.8 || b.reviewCount > 10).slice(0, itemLimit);
    if (BESTSELLERS.length === 0) BESTSELLERS = books.slice(0, itemLimit);

    if (BESTSELLERS.length === 0) return null;

    return (
        <section className="section" style={{
            background: "white",
            paddingTop: "10px",
            paddingBottom: "10px",
            borderTop: "3px solid #C0392B"
        }}>
            <Carousel
                books={BESTSELLERS}
                onView={onView}
                cart={cart}
                addCart={addCart}
                renderHeader={(dots) => <SectionHdr pill="TRENDING NOW" rightContent={dots} />}
            />
        </section>
    );
}
